<template>
  <div class="listContainer" ref="listContainer" :class="{ hidden: loading }" @scroll="onScroll()">
    <div :class="{ messages: true }" v-if="scrollableList.result.list.length >= 1">
      <div
        class="messageContent"
        :class="{
          own: group.from.id === $store.state.profile.id
        }"
        v-for="(group, grIndex) in scrollableList.result.list"
        :key="grIndex"
      >
        <div class="messageHead">
          <img :src="group.from.mainPicture.thumbName" class="miniPhoto" />
        </div>

        <div class="messageGroup">
          <div v-for="(message, index) in group.list" :key="index" class="message">
            <div v-if="canRead || ownMessage(message)" v-html="message.body" class="body" />
            <div v-else class="noPass">
              <div class="info">
                <span class="pseudo">{{ group.from.pseudo }}</span> vous a envoyé un message !<br /><br />
                Un
                <span class="bold">
                  Pass <span class="black">{{ $store.state.siteConst.firstNamePart }}</span
                  ><span class="pinklive">{{ $store.state.siteConst.secondNamePart }}</span></span
                >
                est nécessaire pour lire ce message.
                <p>
                  <span class="pinklive">{{ group.from.pseudo }} pourra vous lire et vous répondre gratuitement</span>
                  si vous disposez du Pass.
                </p>
              </div>
              <div>
                <img src="/assets/images/pass.png" />
              </div>
              <div>
                <router-link class="bouton rose" :to="{ name: 'Pass' }">
                  <span
                    >Obtenir le Pass <span class="pass"> {{ $store.state.siteConst.name }} </span></span
                  >
                </router-link>
              </div>
            </div>
          </div>
          <div class="date">{{ group.ellapsed }}</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="nomessage">
        Vous n'avez encore reçu aucun message...
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { idyu_hasPass } from "@/assets/js/idyu/util.js";

export default {
  name: "ListeMessages",
  data() {
    return {
      scrollableList: { result: { list: [] } },
      profile: Object,
      loading: false,
      transition: 0,
      intervalId: null
    };
  },

  computed: {
    canRead: function() {
      if (idyu_hasPass(this.$store.state.profile.permission)) {
        return true;
      }
      if (!this.$parent.selectedResult) return false;
      return idyu_hasPass(this.$parent.selectedResult.result.profile.permission);
    },

    /*
     ** Return 0 if no information
     ** Return 1 if last send message has been read
     ** Return -1 if the last sent message is unread
     */
    lastSentRead: function() {
      // This information requires Serenity Pass
      if (this.$store.state.profile.permission < 3) return 0;
      const list = this.scrollableList.result.list;

      if (!list || list.length == 0) return 0;

      // Let's find the last message group sent by the current user
      let lastGroup = null;
      let ind = list.length - 1;
      do {
        lastGroup = list[ind];
        ind--;
      } while (ind >= 0 && lastGroup.from.id != this.$store.state.profile.id);
      if (ind == -1) {
        // User hasnt sent any message
        return 0;
      }
      if (!lastGroup.list[lastGroup.list.length - 1].read) return -1;
      else return 1;
    }
  },

  methods: {
    ownMessage: function(msg) {
      return msg.from.id === this.$store.state.profile.id;
    },

    onScroll: function() {
      this.scrollableList.onScroll(this.$refs.listContainer, this.$store);
    },

    scrollDownMessages: async function() {
      await Vue.nextTick();
      this.$refs.listContainer.scrollTop = this.$refs.listContainer.scrollHeight;
    },

    messageRead: function(group) {
      return group.list[group.list.length - 1].read;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.listContainer {
  overflow-y: scroll;
}

.messages {
  overflow-x: hidden;
  display: grid;
  grid-gap: 10px;
  grid-auto-rows: min-content;
  grid-auto-columns: auto;
  padding-bottom: 5px;
  padding-top: 5px;
  padding-right: 3px;
  &.hidden {
    visibility: hidden;
  }
  background-image: url("/assets/images/mangatoiledefond.jpg");
  background-repeat: repeat;
}

.messageContent:not(.own) {
  .messageGroup {
    border-bottom-left-radius: 0;
    margin-left: 5px;

    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0px;
      width: 0;
      height: 0;
      border: 12px solid transparent;
      border-right-color: #f0f0f0;
      border-left: 0;
      border-bottom: 0;
      margin-top: -6px;
      margin-left: -12px;
    }
  }
}

.messageContent {
  display: grid;
  grid-template-columns: min-content auto;
  overflow-wrap: break-word;
  overflow: hidden;
  grid-gap: 10px;
  align-items: end;
  justify-content: start;
  .miniPhoto {
    height: 50px;
    border-radius: 100%;
    box-shadow: $small_shadow;
  }

  &.own {
    justify-content: end;
    .miniPhoto {
      display: none;
    }

    .messageGroup {
      background-color: #e0f4da;
    }
  }

  .messageGroup {
    position: relative;
    background-color: white;
    border-radius: 5px;
    padding: 5px;
    margin-right: 2px;
    margin-left: 0px;
    background-color: #f0f0f0;
    box-shadow: $small_shadow;
    margin-bottom: 2px;
    h3 {
      color: $theme_color;
      margin-bottom: 0;
      padding-top: 0px;
      margin-top: 0px;
      margin-left: 2px;
      font-size: 14px;
    }

    .messageHead {
      display: grid;
      grid-template-columns: auto;
      border: none;
      margin-top: 0px;
      height: auto;

      .from {
        margin-top: 0px;
        margin-right: 0px;
      }
    }

    .body,
    .noPass {
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .noPass {
      position: relative;
      background-color: #f0ece0;
      border-width: 1px;
      border-color: #ccc;
      border-style: solid;
      margin-top: 4px;
      padding: 10px;
      margin-right: 10px;
      display: grid;
      grid-template-columns: auto min-content;
      grid-template-rows: minmax(min-content, 87px) auto;
      grid-gap: 10px;
      justify-content: center;

      .pseudo {
        color: $theme_color;
        font-weight: bold;
      }
      div:nth-child(1) {
        border-width: 1px;
        border-color: #ccc;
        border-style: solid;
        text-align: justify;

        font-size: 14px;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 3px;
        padding-bottom: 3px;
        background: rgb(255, 255, 255);
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 1) 0%,
          rgba(246, 246, 246, 1) 47%,
          rgba(237, 237, 237, 1) 100%
        );
      }
      div:nth-child(2) {
        grid-column: 2;
        grid-row: 1/3;
      }

      div:nth-child(3) {
        grid-column: 1/3;
        grid-row: 2;
        text-align: center;
      }
    }
  }
}

.nomessage {
  background-color: white;
  padding: 10px;
}
.date {
  color: #aaa;
  font-weight: normal;
  font-size: 12px;
  font-style: italic;
  margin-top: 5px;
}

@media screen and (max-width: $no_menuprogress) {
  .messageGroup {
    .body,
    .noPass {
      margin-left: 2px;
    }

    .noPass {
      margin-right: 2px;
      border: none;
      background: none;
      grid-template-columns: min-content auto;
      div:nth-child(1) {
        padding: 5px;
        font-size: 14px;
        grid-column: 1/3;
        grid-row: 1;
      }
      div:nth-child(2) {
        grid-row: 2;
        grid-column: 1;
        img {
          width: 40px;
        }
      }
      div:nth-child(3) {
        display: grid;
        align-items: center;
        grid-row: 2;
        grid-column: 2/3;
        a.bouton {
          display: block !important;
        }
      }
    }

    &.own {
      background-color: #e5f0fc;
    }
  }

  @media screen and (max-width: 290px) {
    .pass {
      display: none;
    }
  }
}
</style>
